module.exports = __webpack_public_path__ + "static/goliath_warrior-f3ed43b7a65109ea0753f615e21c1702.jpg";